import type { BatchProcessDto } from "@fp/admin-api-client";
import type { Query, QueryClient } from "@tanstack/react-query";

export const BATCH_PROCESS_RECONCILE_INTERVAL_MS = 15_000;

const BATCH_PROCESSES_QUERY_PREFIX = "/api/batch-processes";

function isBatchProcessQuery(query: Query): boolean {
  const key = query.queryKey[0];

  return typeof key === "string" && key.startsWith(BATCH_PROCESSES_QUERY_PREFIX);
}

export function getBatchProcessReconcileInterval(
  batches: BatchProcessDto[] | undefined,
): number | false {
  return batches?.some((batch) => !batch.isComplete)
    ? BATCH_PROCESS_RECONCILE_INTERVAL_MS
    : false;
}

export function createBatchProcessRefresh(
  queryClient: QueryClient,
): () => Promise<void> {
  let isRefreshing = false;
  let isRefreshQueued = false;

  return async () => {
    if (isRefreshing) {
      isRefreshQueued = true;
      return;
    }

    isRefreshing = true;

    try {
      do {
        isRefreshQueued =
          queryClient.isFetching({ predicate: isBatchProcessQuery }) > 0;

        await queryClient.invalidateQueries(
          { predicate: isBatchProcessQuery },
          { cancelRefetch: false },
        );
      } while (isRefreshQueued);
    } finally {
      isRefreshing = false;
    }
  };
}